module.exports = __webpack_public_path__ + "img/AS.2a5f1d16.png";